import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Импортируем ваши файлы переводов
import translationEN from "./locales/en.json";
import translationRU from "./locales/ru.json";
import translationUK from "./locales/uk.json";

// Версия переводов для бастинга кэша Telegram WebView
const TRANSLATIONS_VERSION = "2.3.0"; // Увеличиваем версию после изменения структуры статусов

// Определяем ресурсы
// JSON файлы уже содержат корневой ключ "translation", поэтому используем .translation
const resources = {
  en: translationEN,
  ru: translationRU,
  uk: translationUK,
};

i18n
  // Подключаем плагин для определения языка браузера
  .use(LanguageDetector)
  // Передаем экземпляр i18n в react-i18next
  .use(initReactI18next)
  // Инициализируем i18next
  .init({
    resources,
    fallbackLng: "en", // Язык по умолчанию, если язык пользователя не найден
    debug: import.meta.env.DEV, // Включаем логи только в режиме разработки
    interpolation: {
      escapeValue: false, // React уже защищает от XSS
    },
    detection: {
      // Порядок определения языка:
      // 1. localStorage (если пользователь уже выбирал язык)
      // 2. Язык браузера
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: `i18nextLng_v${TRANSLATIONS_VERSION}`, // Версионированный ключ
    },
  });

export default i18n;
